import type { Network } from "../types";

export const line: Network = {
  name: "LINE",
  shareUrl: "https://social-plugins.line.me/lineit/share?url=[u]",
  args: {
    title: "&text=[t]",
  },
  icon: "/media/images/facebook-social-auth.svg",
  color: "#06C655",
};
